import { render, staticRenderFns } from "./corporateInformation.vue?vue&type=template&id=7def28a9&scoped=true&"
import script from "./corporateInformation.vue?vue&type=script&lang=js&"
export * from "./corporateInformation.vue?vue&type=script&lang=js&"
import style0 from "./corporateInformation.vue?vue&type=style&index=0&id=7def28a9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7def28a9",
  null
  
)

export default component.exports